import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ICreditCard } from './credit-card-list-element.interface';

@Component({
    selector: 'mlp-ng-credit-card-list-element',
    templateUrl: './credit-card-list-element.component.html',
    styleUrls: ['./credit-card-list-element.component.scss']
})

export class CreditCardListElementSharedComponent {
    @Input() card: ICreditCard;
    @Input() edit: boolean;
    @Input() selected: boolean;
    @Input() selectable = true;
    @Input() path = '/assets/cc-logos/';

    @Output() add = new EventEmitter();
    @Output() select = new EventEmitter();
    @Output() remove = new EventEmitter();

    cardLogo(): string {
        let icon = 'generic';

        if (this.card && this.card.attributes && this.card.attributes.brand) {
            if (this.card.attributes.brand === 'American Express') {
                icon = 'amex';
            } else {
                icon = this.card.attributes.brand.toLowerCase().split(/\s/g)[0];
            }
        }

        return `${this.path}${icon}.svg`;
    }

    expiry(): string {
        return [
            this.card.attributes.exp_month.toString().padStart(2, '0'), // pad expiry month to 2 characters
            this.card.attributes.exp_year.toString().substr(-2) // get only last 2 characters of expiry year
        ].join('/'); // join with slash
    }
}
